//#region Libraries
import styled from "styled-components";
//#endregion

export const HeaderAdviser = styled.h4`
    display: grid;
    place-items: center;
    margin: 0;
    font-size: 13px;
    text-align: center;
    & span {
        padding: 0 10px;
        max-width: 150px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;